import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from '@reduxjs/toolkit';
import { resetAddressData, resetUserData, setFlat, setHouse, setPhoneNumber, setStreet } from '@fttb/common';
export var userData = createReducer({
  flat: '',
  isFetched: false,
  userPhoneNumber: '',
  house: {
    label: '',
    id: ''
  },
  street: {
    label: '',
    id: ''
  }
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, setFlat.type, function (state, _ref) {
  var payload = _ref.payload;
  state.flat = payload;
}), setHouse.type, function (state, _ref2) {
  var payload = _ref2.payload;
  state.house = payload;
}), setStreet.type, function (state, _ref3) {
  var payload = _ref3.payload;
  state.street = payload;
}), setPhoneNumber.type, function (state, _ref4) {
  var payload = _ref4.payload;
  state.userPhoneNumber = payload;
}), resetUserData.type, function (state) {
  state.userPhoneNumber = '';
}), resetAddressData.type, function (state) {
  state.street = {
    label: '',
    id: ''
  };
  state.house = {
    label: '',
    id: ''
  };
  state.flat = '';
}));